// extracted by mini-css-extract-plugin
export default {"overlay":"LoaderModal_overlay__qb+Ju","modal":"LoaderModal_modal__CXADM"};